import { createContext, useContext, useEffect, useState } from 'react';
import { http, formatError } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=anon, obj=user
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;
    http.get('/auth/me').then(r => {
      if (alive) setUser(r.data);
    }).catch(() => {
      if (alive) setUser(false);
    });
    return () => { alive = false; };
  }, []);

  const login = async (email, password) => {
    setError('');
    try {
      const { data } = await http.post('/auth/login', { email, password });
      setUser(data);
      return { ok: true };
    } catch (e) {
      const m = formatError(e);
      setError(m);
      return { ok: false, error: m };
    }
  };

  const register = async (name, email, password) => {
    setError('');
    try {
      const { data } = await http.post('/auth/register', { name, email, password });
      setUser(data);
      return { ok: true };
    } catch (e) {
      const m = formatError(e);
      setError(m);
      return { ok: false, error: m };
    }
  };

  const logout = async () => {
    await http.post('/auth/logout').catch(() => {});
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, register, logout, error }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
